import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { visibility } from "../../redux/slices/rightSideAd";
import "./AdminMaterials.scss";
import images from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { getScreenDimensions } from "../../utils/helper";
import {
  classroomByIdDetailsType,
  classroomListType,
  classroomObjectType,
} from "../AdminClassroom/AdminClassroom";
import { useLazyQuery } from "@apollo/client";
import { GET_CLASSROOM_LIST } from "../AdminDashboard/api/AdminDashboardQuery";
import Loader from "../../components/Loader/Loader";
import { Tooltip } from "@mui/material";
import { debounce } from "lodash";
import TabsContentHeader from "../../components/AdminDashboardTabsContentHeader/TabsContentHeader";
import MobileScreenHeader from "../../components/MobileScreenHeader/MobileScreenHeader";
import { GET_CLASSROOM_BY_ID } from "../AdminClassroom/api/AdminClassroomQuery";
import { useDispatch } from "react-redux";
import { setClassroomId, setClassroomName } from "../../redux/slices/CommonUploadSlice";

const AdminMaterials = () => {
  const dispatch = useAppDispatch();
  dispatch(visibility({ isVisible: true }));
  const { bookIcon, searchCloseIcon } = images;
  const navigate = useNavigate();
  const [classroomsList, setAllClassroomsList] = useState<classroomListType>();
  const [refetchData, setRefetchData] = useState<boolean>(false);
  const { isMobileScreen } = getScreenDimensions();
  const [searchValue, setSearchValue] = useState<string>("");
  const profileImage = useAppSelector(
    (state) => state?.auth?.adminProfileImage
  );
  const role = useAppSelector((state) => state.auth.role);
  const profile = useAppSelector((state) => state.auth.adminProfile);
  const StudentName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;
  const [isSearchClick, setisSearchClick] = useState<boolean>(false);
  const [selectedCId, setSelectedCId] = useState<string>('')

  const [getAllClassroom, { loading }] = useLazyQuery(GET_CLASSROOM_LIST, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      console.log(data, "data");
      setAllClassroomsList(data);
      setRefetchData(false);
    },
  });

  useEffect(() => {
    getAllClassroom({
      variables: {
        orderBy: ["C_NAME_ASC"],
        searchInput: "%%",
      },
    });
  }, []);

  const handleSearchDebounce = useCallback(
    debounce((value) => {
      setSearchValue(value);
      getAllClassroom({
        variables: {
          orderBy: ["C_NAME_ASC"],
          searchInput: `%${value.trim()}%`,
        },
      });
    }, 500),
    [getAllClassroom]
  );

  const handleCloseSearch = () => {
    setSearchValue("");
    handleSearchDebounce("");
    setisSearchClick(false);
  };

  const searchOnChange = (event: { target: { value: string } }) => {
    setSearchValue(event.target.value);
    if (handleSearchDebounce) {
      handleSearchDebounce(event?.target?.value);
    }
  };

  const handleSearchClick = () => {
    setisSearchClick(true);
  };


  const getClassroomDetails = (cId: string, cName : string) => {
    console.log(cId, "cId")
    setSelectedCId(cId)
    dispatch(setClassroomId(cId))
    dispatch(setClassroomName(cName))
    navigate('/admin-materials-upload/materials')
  };

  const handleClickBulkUpload = () => {
    navigate("/admin-materials-upload/bulk-upload")
  }

  return (
    <div className="admin-materials">
      {isMobileScreen ? (
        isMobileScreen && !isSearchClick ? (
          <div className="adminMobileHeader">
            {/* <MobileHeader /> */}
            <MobileScreenHeader
              profileImage={profileImage}
              role={role}
              studentName={StudentName}
              profile={profile}
              handleSearchClick={handleSearchClick}
            />
            <div className="mobileDashboardTitleTextStyle">Dashboard</div>
          </div>
        ) : (
          <div className={"adminClassroomSearch"}>
            <input
              id="searchBox"
              type="text"
              placeholder="Search"
              onChange={searchOnChange}
              value={searchValue}
              className="SearchInputFieldStyle"
            />
            {getScreenDimensions()?.isMobileScreen && isSearchClick && (
              <img
                src={searchCloseIcon}
                alt="closeIcon"
                className="closeIcon"
                onClick={handleCloseSearch}
              />
            )}
          </div>
        )
      ) : (
        <TabsContentHeader
          title={"Upload"}
          subtitle={"Bulk Upload"}
          addLabel={"Bulk Upload"}
          subImage={bookIcon}
          handleSearchDebounce={handleSearchDebounce}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          handleClickBulkUpload = {handleClickBulkUpload}
        />
      )}
      {loading || classroomsList === undefined ? (
        <Loader bottom="150px" />
      ) : (
        <div
          className={`${
            classroomsList?.allClassrooms?.totalCount
              ? "classroomListContainer"
              : "forNoDataFound"
          }`}
        >
          {classroomsList?.allClassrooms?.totalCount ? (
            classroomsList?.allClassrooms?.nodes?.map(
              (cardItem: classroomObjectType, index: number) => {
                return (
                  <div
                    className="classCardContainer"
                    key={`${index}-${cardItem?.cId}`}
                    onClick={() => {getClassroomDetails(cardItem?.cId, cardItem?.cName)}}
                  >
                    <div className="topSectionName">
                      <Tooltip
                        title={<span>{cardItem?.cOriginalName}</span>}
                        // disableHoverListener={!isOverflow[index]}
                        placement="top"
                      >
                        <label
                          className="classRoomNameStyle"
                          // ref={(el) => (classNameRefs.current[index] = el)}
                          // onMouseEnter={() => checkOverflow(index)}
                        >
                          {cardItem?.cOriginalName}
                        </label>
                      </Tooltip>
                    </div>
                  </div>
                );
              }
            )
          ) : (
            <div className="noDataFoundStyle">No data found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminMaterials;
